import api from "../global/Api";
import { ENDPOINTS } from "../global/ApiEndpoints";

export const getAllSpiraxSarcoPrices = async (page, size, searchString) => {
    const response = await api.get(`/${ENDPOINTS.SPIRAX_SARCO_PRICE_TABLE}`, {
        params: { page, size, search: searchString },
    });
    return response.data;
};

export const updateSpiraxSarcoPrice = async (id, body) => {
    const response = await api.put(`/${ENDPOINTS.SPIRAX_SARCO_PRICE_TABLE}/${id}`, body);
    return response.data;
};

export const getSpiraxSarcoPriceSourcePdf = async () => {
    const response = await api.get(`/${ENDPOINTS.SPIRAX_SARCO_PRICE_TABLE}/source`, {
        responseType: "blob",
    });
    return response.data;
};